var autoChangeFeatures;

class FeaturesWithBenifitsJs{
  constructor(){
    this.init();
  }

  /* 
  * Function for auto changing feature for home page
  */
  autoChangingFeatures() {
    var allFeatures = document.querySelectorAll('.auto-changing-features [data-text-count]');
    if (allFeatures.length > 0) {
      var featuresLength = allFeatures.length;
      var activatedFeature = parseInt(document.querySelector('.auto-changing-features .active[data-text-count]').getAttribute('data-text-count'));
      
      this.autoSwappingFeatureInterval(activatedFeature, featuresLength, false);

      const that = this;
      allFeatures.forEach(feature => {
        feature.addEventListener('click', (e) => {
          clearInterval(autoChangeFeatures); 
          activatedFeature = parseInt(feature.getAttribute('data-text-count'));
          that.autoSwappingFeatureInterval(activatedFeature, featuresLength, true);
        })
      })
    }
  }

  /** 
  *  Function for auto changing feature for home page, interval management
  *  @param {Integer} activatedFeature
  *  @param {Integer} featuresLength
  *  @param {Boolean} isClicked
  */

  
  autoSwappingFeatureInterval(activatedFeature, featuresLength, isClicked) {
    if (isClicked) {
      document.querySelector('.auto-changing-features .active[data-text-count]').classList.remove('active');
      document.querySelector('.auto-changing-features .active[data-image-count]').classList.add('d-none');
      document.querySelector('.auto-changing-features .active[data-image-count]').classList.remove('active');
      document.querySelector(`.auto-changing-features [data-text-count="${activatedFeature}"]`).classList.add('active');
      document.querySelector(`.auto-changing-features [data-image-count="${activatedFeature}"]`).classList.add('active');
      document.querySelector(`.auto-changing-features [data-image-count="${activatedFeature}"]`).classList.remove('d-none');
      isClicked = false;
    }
    autoChangeFeatures = setInterval(() => {
      document.querySelector('.auto-changing-features .active[data-text-count]').classList.remove('active');
      document.querySelector('.auto-changing-features .active[data-image-count]').classList.add('d-none');
      document.querySelector('.auto-changing-features .active[data-image-count]').classList.remove('active');
      
      if (activatedFeature == featuresLength) { activatedFeature = 1; } else { activatedFeature++; }
      document.querySelector(`.auto-changing-features [data-text-count="${activatedFeature}"]`).classList.add('active');
      document.querySelector(`.auto-changing-features [data-image-count="${activatedFeature}"]`).classList.add('active');
      document.querySelector(`.auto-changing-features [data-image-count="${activatedFeature}"]`).classList.remove('d-none');
    }, 3000);
  }

  init() {
    this.autoChangingFeatures();
  }
}
new FeaturesWithBenifitsJs;